export enum UserActionTypes {
  USER_INFO = 'USER_INFO',
  NEW_USER_STATE = 'NEW_USER_STATE',
  UPDATE_USER_AUTHED_DATA = 'UPDATE_USER_AUTHED_DATA',
  UPDATE_USER_OWN_DATA = 'UPDATE_USER_OWN_DATA',
  LOG_OUT = 'LOG_OUT',
  SAVE_TOKEN = 'SAVE_TOKEN',
  NEW_TOKEN = 'NEW_TOKEN',
}
